import {NotificationHandler} from './notification-handler';
import {Notification} from '../../models/notification.class';

export class NullNotificationHandler implements NotificationHandler {
    handle(notification: Notification): void {
        //
    }
}
